// extracted by mini-css-extract-plugin
module.exports = {"button":"AdvDetailedButton_button__lEX_6"};